import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import httpClient from 'utils/httpClient';
import { CHAT_BACKEND_URL } from 'configs/env.conf';

export type CreateLiveKitRoomBody = {
  studentIds: number[];
  callType: 'video' | 'audio';
};

export type CreateLiveKitRoomResponse = {
  roomId: string;
  token: string;
  livekitUrl: string;
};

export const createLiveKitRoom = (body: CreateLiveKitRoomBody) =>
  httpClient.post<CreateLiveKitRoomResponse>('/livekit/teacher-room', body, {
    baseURL: CHAT_BACKEND_URL,
  });

export const useCreateLiveKitRoom = (
  opts?: UseMutationOptions<
    AxiosResponse<CreateLiveKitRoomResponse>,
    AxiosError<any>,
    CreateLiveKitRoomBody
  >,
) =>
  useMutation<
    AxiosResponse<CreateLiveKitRoomResponse>,
    AxiosError<any>,
    CreateLiveKitRoomBody
  >(createLiveKitRoom, opts);
